import { render, staticRenderFns } from "./CoursewareUnitProgress.vue?vue&type=template&id=585808d4&"
import script from "./CoursewareUnitProgress.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports